import { FC, memo, useEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import * as am5percent from '@amcharts/amcharts5/percent';
import { Card, Empty, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

const { Title } = Typography;

const ITEM_HEIGHT = 250;

interface IProps {
  data: {
    value: number;
    category: string;
  }[];
  total: number;
}

const AppointmentsGender: FC<IProps> = ({ data, total }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!data?.length) {
      return;
    }

    const root = am5.Root.new('AppointmentsGender');

    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5percent.PieChart.new(root, {
        layout: root.verticalLayout,
        innerRadius: am5.percent(50)
      })
    );

    const series = chart.series.push(
      am5percent.PieSeries.new(root, {
        valueField: 'value',
        categoryField: 'category',
        alignLabels: false
      })
    );

    series.labels.template.setAll({
      textType: 'circular',
      visible: false,
      centerX: 0,
      centerY: 0
    });

    series.data.setAll(data);

    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.percent(50),
        x: am5.percent(50),
        marginTop: 15,
        marginBottom: 15
      })
    );

    legend.data.setAll(series.dataItems);

    series.appear(1000, 100);

    return () => root.dispose();
  }, [data]);

  return (
    <Card
      title={
        <>
          <Title level={5} style={{ marginTop: 16 }}>
            {t('dashboard.appointments_gender')}
          </Title>
          <Title level={2} style={{ marginTop: 4 }}>
            {t('dashboard.total', { count: total })}
          </Title>
        </>
      }
      className="chart-card"
    >
      {data ? (
        <div id="AppointmentsGender" style={{ height: ITEM_HEIGHT }} />
      ) : (
        <Empty style={{ height: ITEM_HEIGHT }} />
      )}
    </Card>
  );
};

export default memo(AppointmentsGender);
